<template lang="pug">
main(v-if="Show")
  section.top-image(:style="{height: topImageHeight()}")
    img.image(src='../assets/top_image_03.png' :class="[IsTopShow(0), ImageClass()]" ref="topImage")
    img.image(src='../assets/top_image_05.png', :class="[IsTopShow(1), ImageClass()]")
    img.image(src='../assets/top_image_04.png' :class="[IsTopShow(2), ImageClass()]")
    img.image(src='../assets/top_image_02.png', :class="[IsTopShow(3), ImageClass()]")

  parallax-inview
    animation-fade-in-up
      section.top-section
        h2.title いつまでも若々しく美しい髪に
        p.top-detail 当店は、髪に悩む女性にちゃんと寄り添いたい・・・そんな思いで蔵前にオープンしたその場しのぎではない、根本改善を目指す特別なサロンです。<br>本当に美しい髪を目指すにあたりサロンケアのみではなく、ホームケアの重要性にも着目しております。<br><br>現在最高品質と言われているコタアイケア、アジュバンリシャンプー、オッジオットシリーズ、ミネコラなど一般のドラックストアでは販売していない最高級シャンプーを取り揃えました。更にその中からお客様の髪質やお悩みに合わせてベストなものをご提供いたします。

  parallax-inview
    animation-fade-in-up
      section.section
        img.top-image-detail(src='../assets/image_shampoo_01.jpg')

  parallax-inview
    animation-fade-in-up
      section.section
        p.top-detail ・パサつき、うねり、枝毛、まとまり等、髪の悩みを改善していきたい<br>・年齢と共に艶、ハリコシがなくなってきた<br>・今までのサロントリートメントで満足した事がない<br><br>そんな髪の悩みに寄り添い、共に試行錯誤を繰り返し、いつまでも若々しく美しい髪へと導きます。シャンプー、トリートメントのみの販売も致しております。蔵前、浅草周辺にお越しの際は是非お気軽にお立ち寄りください。また、既に行きつけの美容室がある方も髪質改善のみでのご来店を多数頂いております。髪質改善のみや販売のみの方も大歓迎です！

  //- parallax-inview
  //-   animation-fade-in-up
  //-     section.infection-reflect
  //-       p.title -新型コロナウイルス感染拡大予防の取り組み-
  //-       p 衛生面、消毒を徹底しております<br>お客様にも手指消毒をお願いしております
  //-       p 皆様とスタッフの安心・安全を第一に考え<br>細心の注意を払いながら営業しております。<br>＃詳しい予防の取り組みは動画をご覧ください。<br>皆様のご理解ご協力をお願い申し上げます。

  //- parallax-inview
  //-   animation-fade-in-up
  //-     video.infection-video(controls)
  //-       source(src="../assets/infection-video-01.mp4")
  //-     video.infection-video(controls)
  //-       source(src="../assets/infection-video-02.mp4")
  section.link-list
    parallax-inview
      animation-fade-in-up
        router-link.box.is-left(to="/Shampoo")
          .box-image
            img.image(src='../assets/top_concept_image.png')
          .box-info
            p.title Shampoo
            p.description 新しい出会い
    parallax-inview
      animation-fade-in-up
        router-link.box.is-right(to="/Concept")
          .box-info
            p.title Concept
            p.description 今を変える
          .box-image
            img.image(src='../assets/top_shampoo_image.png')
    parallax-inview
      animation-fade-in-up
        router-link.box.is-left(to="/Reserve")
          .box-image
            img.image(src='../assets/top_reverve_image.png')
          .box-info
            p.title Reserve
            p.description いつでも美しい髪に

  parallax-inview
    animation-fade-in-up
      section.section.recruit
        p スタイリスト募集中！詳しくはお問い合わせください。<br>担当 : you

</template>

<script>
import ParallaxBase from './parallax/ParallaxBase.vue'
import ParallaxFloat from './parallax/ParallaxFloat.vue'
import ParallaxInview from './parallax/ParallaxInview.vue'
import AnimationFadeIn from './effect/animation/AnimationFadeIn.vue'
import AnimationFadeInUp from './effect/animation/AnimationFadeInUp.vue'
import AnimationWiden from './effect/animation/AnimationWiden.vue'
import AnimationWidenShadow from './effect/animation/AnimationWidenShadow.vue'

export default {
  head: {
    title() {
      return {
        inner: 'Shampoo Selection',
        separator: '|',
        complement: 'シャンプーセレクション 蔵前美容室',
      }
    },
    link: [
      { rel: 'preconnect', href: 'https://fonts.gstatic.com' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@200;300;400;500;600;700;900&display=swap' }
    ]
  },
  props: ['loadingEnd'],
  components: {
    ParallaxBase,
    ParallaxFloat,
    ParallaxInview,
    AnimationFadeIn,
    AnimationFadeInUp,
    AnimationWiden,
    AnimationWidenShadow
  },
  computed: {
    Show:{
      get: function() {
        return this.loadingEnd
      }
    }
  },
  data() {
    return {
      isFirst: true,
      topImageScequence: 0,
      lastScequence: 4,
      imageHeight: 0
    }
  },
  mounted: function() {
    this.Initialize()
  },
  methods: {
    async Initialize() {
      if (!this.loadingEnd) {
        await new Promise(resolve => setTimeout(resolve, 3500))
        this.AdujustImageHeight(true)
      } else {
        this.AdujustImageHeight(false)
      }

      this.topImageScequence = this.lastScequence
      this.AnimStart()
    },
    async AdujustImageHeight(isLoading) {
      if (!isLoading) {
        await new Promise(resolve => setTimeout(resolve, 300))
      }

      this.imageHeight = this.$refs.topImage.getBoundingClientRect().height
    },
    async AnimStart() {
      for(let i = 0; i < this.lastScequence; i++) {
        await new Promise(resolve => setTimeout(resolve, 5000))

        if (this.isFirst) {
          this.isFirst = false
        }

        this.topImageScequence = i + 1
      }

      this.AnimStart()
    },
    IsTopShow: function(index) {
      let showClass = ''

      for(let i = 0; i < this.lastScequence; i++) {
        if (this.topImageScequence === (i + 1)) {

          if (i === this.lastScequence - 1) {
            if (this.isFirst) {
              if (index === 0) {
                showClass = 'is-show'
              }
            } else if (index === i || index === 0) {
              showClass = 'is-show'
            }
          } else {
            if (index === i || index === (i + 1)) {
              showClass = 'is-show'
            }
          }
        }
      }

      return showClass
    },
    ImageClass: function() {
      if (this.topImageScequence === this.lastScequence) {
        return 'is-last'
      }
    },
    topImageHeight: function() {
      if (this.imageHeight == 0) {
        return
      }
      return this.imageHeight + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  padding: 0;
  margin-top: 0;
}
@keyframes top-image {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.top-image {
  height: 470px;
  margin-bottom: 50px;
  position: relative;
  overflow: hidden;
  z-index: 1;
  background: #000;
  .image {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transform: scale(1);
    transition: transform 5s linear;
    &.is-last {
      &:first-child {
        z-index: 2;
      }
      &:nth-child(3) {
        z-index: 1;
      }
    }
    &.is-show {
      transform: scale(1.06);
      animation: top-image 2s;
      animation-timing-function: cubic-bezier(0.8, 0, 0.2, 1);
      animation-fill-mode: both;
    }
  }
}
.image {
  width: 100%;
}

.top-section {
  > .title {
    padding: 0 10px 40px;
  }
  .top-detail {
    margin-bottom: 20px;
  }
}

.top-detail {
  text-align: left;
  padding: 0 25px 40px;
}
.top-image-detail {
  margin-bottom: 40px;
}
.infection-reflect {
  background-image: url('../assets/top_infection_reflect_bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 64px 0;
  font-size: 13px;
  margin-bottom: 40px;
  > p {
    line-height: 31px;
    margin-bottom: 35px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.infection-video {
  width: 100%;
  height: 225px;
}

.link-list {
  .box {
    position: relative;
    display: flex;
    justify-content: space-between;
    margin: 50px 25px 0;
    height: 140px;
    text-decoration: none;
    &:before {
      content: '';
      position: absolute;
      border: 1px solid #999999;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      z-index: 2;
    }
    &.is-left {
      .box-image {
        top: -10px;
        left: 20px;
        > .image {
          box-shadow: -34px 28px 15px rgba(47,29,13,0.8);
        }
      }
      .box-info {
        text-align: right;
      }
    }
    &.is-right {
      .box-image {
        top: -10px;
        left: -20px;
        > .image {
          box-shadow: 34px 28px 15px rgba(47,29,13,0.8);
        }
      }
      .box-info {
        text-align: left;
      }
    }
    .box-image {
      position: relative;
      width: 135px;
      z-index: 1;
      margin: 0;
    }
    .box-info {
      width: 130px;
      margin: 5px 12px 0;
      height: 100%;
      > .title {
        font-weight: bold;
        font-size: 24px;
        border-bottom: 1px solid #fff;
      }
    }
  }
}

.recruit {
  margin-top: 80px;
  padding: 20px 0;
  background: #fff;
  color: #000;
}

.v-enter {
  opacity: 0;
  &-to {
    opacity: 1;
  }
  &-active{
    transition: all 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
  }
}
.v-leave {
  opacity: 1;
  &-to {
    opacity: 0;
  }
  &-active{
    transition: all 0.2s cubic-bezier(0.2, 0.8, 0.2, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue